import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-app-table-individual-informations',
  templateUrl: './app-table-individual-informations.component.html',
  styleUrls: ['./app-table-individual-informations.component.scss'],
  standalone: false,
})
export class AppTableIndividualInformationsComponent implements OnInit {
  @Input() code?: string;

  constructor() {}

  ngOnInit(): void {}
}
